import { actionTypes } from "../Action/OnevascoAction";


const INITIAL_STATE = {
    onevascoloader: false,
    BranchList: [],
    ValidateFile: null,
    MemberList: [],
    AllBranchList: [],
};

const OnevascoReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.LOADER:
            return {
                ...state,
                onevascoloader: action.onevascoloader,
            };
        case actionTypes.BRANCH_LIST:
            return {
                ...state,
                BranchList: action.BranchList,
                onevascoloader: false,
            };
        case actionTypes.VALIDATE_FILE:
            return {
                ...state,
                ValidateFile: action.ValidateFile,
                onevascoloader: false,
            };
        case actionTypes.MEMBER_LIST:
            return {
                ...state,
                MemberList: action.MemberList,
                onevascoloader: false,
            };
        case actionTypes.ALL_BRANCH_LIST:
            return {
                ...state,
                AllBranchList: action.AllBranchList,
                onevascoloader: false,
            };
        default:
            return state;
    }
};

export default OnevascoReducer;